import { ICommonQueryParams } from "taskpane/models/interfaces";
import { API } from "./api";

export const COMMON_QUERY_PARAMS: Readonly<ICommonQueryParams> = {
  clientName: "VKTeams Outlook Add-In",
  clientVersion: "1",
  k: window.vkTeams.config.clientId || API.defaultClientId,
};
